// The two operating companies share all details — only the printed name differs.
// ITO Engineering is the default (listed first).
export const COMPANY_BRANDS = [
  { id: "ito_engineering", name: "ITO Engineering Infra Pvt Ltd" },
  { id: "ito", name: "Indian Transport Organisation" },
];

export function brandName(id) {
  const b = COMPANY_BRANDS.find((x) => x.id === id);
  return b ? b.name : "";
}
